import common from './common.zh-CN';
import formDetail from '../views/form/locale/zh-CN';
import form from '@cloudpivot/form/locales/zh-CN';
import flowCenter from '@cloudpivot/flow-center/locales/zh-CN';
import list from '@cloudpivot/list/locales/zh-CN';
import flow from '@cloudpivot/flow/locales/zh-CN';
import formComment from '@cloudpivot/form-comment/locales/zh-CN';
import application from '@cloudpivot/application/locales/zh-CN';
import cloudpivotCommon from '@cloudpivot/common/locales/zh-CN';
export default {
    cloudpivot: {
        form,
        flowCenter,
        list,
        flow,
        formComment,
        application,
        cloudpivotCommon
    },
    languages: {
        common,
        form: formDetail
    }
};
